// extracted by mini-css-extract-plugin
export default {"container":"MobileWatermark_container__Jcyrr","label":"MobileWatermark_label__PbbCf","logo":"MobileWatermark_logo__Sq1we"};